import { svg } from "../svg";

const BitwardenShield = svg`
<svg class="tw-fill-fg-nav" version="1.1" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
 <g transform="matrix(1.33,0,0,1.33,-1.86e-4,3.72e-4)">
  <g transform="matrix(.438 0 0 .432 -2.79 -2.9)">
   <rect x="6.35" y="6.78" width="12.7" height="55.7" stroke-width=".258"/>
   <rect x="24" y="6.78" width="37.3" height="11.9" stroke-width=".205"/>
   <rect x="24" y="29" width="37.3" height="11.9" stroke-width=".205"/>
  </g>
 </g>
</svg>
`;

export { BitwardenShield };
